/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditRoute);
